import { Button } from "melodies-source/Button";
import { Modal } from "melodies-source/Modal";
import { Body1 } from "melodies-source/Text";
import { useState } from "react";
import { CenterFlexRow } from "Routes/styled";
import styled from "styled-components";

export const RemoveWinnerModal = ({
  onConfirm,
  isOpen,
  onClose,
  winnerName,
}: {
  isOpen: boolean;
  onConfirm: () => Promise<void>;
  onClose: () => void;
  winnerName: string;
}) => {
  const [removingWinner, setRemovingWinner] = useState(false);

  return (
    <Modal header="Remove Winner" isOpen={isOpen} onClose={onClose}>
      <Body1 style={{ color: "#000", marginBottom: 30 }}>
        Are you sure you want to remove {winnerName} as a winner? You will have
        the option to replace them.
      </Body1>
      <ButtonContainer>
        <StyledCancelButton variant="tertiary" onClick={onClose}>
          Cancel
        </StyledCancelButton>
        <StyledConfirmButton
          loading={removingWinner}
          onClick={async () => {
            setRemovingWinner(true);
            await onConfirm();
            setRemovingWinner(false);
            onClose();
          }}
        >
          Remove
        </StyledConfirmButton>
      </ButtonContainer>
    </Modal>
  );
};

export const ReplaceWinnerModal = ({
  isOpen,
  onClose,
  onConfirm,
  winnerName,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  winnerName: string;
}) => {
  return (
    <Modal header="Replace Winner" isOpen={isOpen} onClose={onClose}>
      <Body1 style={{ color: "#000", marginBottom: 30 }}>
        Are you sure you want to replace {winnerName} as a winner? Another
        random eligible contact will be chosen.
      </Body1>
      <ButtonContainer>
        <StyledCancelButton variant="tertiary" onClick={onClose}>
          Cancel
        </StyledCancelButton>
        <StyledConfirmButton
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          Replace
        </StyledConfirmButton>
      </ButtonContainer>
    </Modal>
  );
};

export const ResetSweepsModal = ({
  isOpen,
  onClose,
  onConfirm,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  return (
    <Modal header="Reset Contest" isOpen={isOpen} onClose={onClose}>
      <Body1 style={{ color: "#000", marginBottom: 30 }}>
        Are you sure you want to reset ignored and winning entries?
      </Body1>
      <ButtonContainer>
        <StyledCancelButton variant="tertiary" onClick={onClose}>
          Cancel
        </StyledCancelButton>
        <StyledConfirmButton
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          Confirm
        </StyledConfirmButton>
      </ButtonContainer>
    </Modal>
  );
};

const StyledCancelButton = styled(Button)`
  ${({ theme }) => theme.mediaQueries.desktop} {
    margin-right: 13px;
  }
  ${({ theme }) => theme.mediaQueries.mobile} {
    width: 100%;
  }
`;

const StyledConfirmButton = styled(Button)`
  ${({ theme }) => theme.mediaQueries.mobile} {
    width: 100%;
  }
`;

const ButtonContainer = styled(CenterFlexRow)`
  ${({ theme }) => theme.mediaQueries.desktop} {
    align-self: flex-end;
  }
  ${({ theme }) => theme.mediaQueries.mobile} {
    flex-direction: column-reverse;
    width: 100%;
  }
`;
